import React, { useState, useEffect, Fragment } from "react";
import "../styles/registerDevice.css";
import { IonButton, IonCardContent, IonTitle } from "@ionic/react";
import { handleRegisterSite } from "../service/adminUI";
import SessionManager from "../service/SessionManager";

const RegisterSite = ({ bckimgChange, setRegisterToast }) => {
  const TOAST_ERROR = "toast toast-error";
  const TOAST_SUCCESS = "toast toast-success";

  const [name, setName] = useState("");
  const [address, setAddress] = useState("");
  const [city, setCity] = useState("");
  const [country, setCountry] = useState("");
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (bckimgChange) bckimgChange("registerDevice.png");
  }, [bckimgChange]);

  const clearForm = () => {
    setName("");
    setAddress("");
    setCity("");
    setCountry("");
  };

  const doRegister = async () => {
    if (!name.trim() || !address.trim() || !city.trim() || !country.trim()) {
      setRegisterToast &&
        setRegisterToast({
          css: TOAST_ERROR,
          message: "Site Name, Address, City and Country are all required",
        });
      return;
    }
    setSubmitting(true);
    try {
      const result = await handleRegisterSite(
        {
          name: name.trim(),
          address: address.trim(),
          city: city.trim(),
          country: country.trim(),
        },
        SessionManager.getAccessToken()
      );
      if (result.ok) {
        setRegisterToast &&
          setRegisterToast({
            css: TOAST_SUCCESS,
            message: `Site registered successfully (site:${result.siteId})`,
          });
        clearForm();
      } else {
        setRegisterToast &&
          setRegisterToast({
            css: TOAST_ERROR,
            message: "Error: " + (result.error || "Site registration failed"),
          });
      }
    } catch (err) {
      setRegisterToast &&
        setRegisterToast({
          css: TOAST_ERROR,
          message: "Error: " + err.message,
        });
    }
    setSubmitting(false);
  };

  return (
    <Fragment>
      <IonTitle className="device-title">Register Site</IonTitle>
      <IonCardContent className="device-content">
        <form
          className="device-form charger-provision-form"
          onSubmit={(e) => e.preventDefault()}
        >
          <div className="field-row">
            <label className="field-label">Site Name *</label>
            <input
              data-testid="TSITE_NAME"
              className="field-input"
              placeholder="AIIMS Hyderabad"
              value={name}
              onChange={(e) => setName(e.target.value)}
            />
          </div>
          <div className="field-row">
            <label className="field-label">Address *</label>
            <input
              data-testid="TSITE_ADDRESS"
              className="field-input"
              placeholder="Bibinagar, Hyderabad, Telangana"
              value={address}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          <div className="field-row">
            <label className="field-label">City *</label>
            <input
              data-testid="TSITE_CITY"
              className="field-input"
              placeholder="Hyderabad"
              value={city}
              onChange={(e) => setCity(e.target.value)}
            />
          </div>
          <div className="field-row">
            <label className="field-label">Country *</label>
            <input
              data-testid="TSITE_COUNTRY"
              className="field-input"
              placeholder="IN"
              value={country}
              onChange={(e) => setCountry(e.target.value)}
            />
          </div>
        </form>
      </IonCardContent>
      <div className="homeMainFooter">
        <IonButton
          class="loginButton"
          fill="solid"
          shape="round"
          onClick={clearForm}
          disabled={submitting}
        >
          Cancel
        </IonButton>
        <IonButton
          data-testid="TSITE_REGISTER"
          class="loginButton"
          fill="solid"
          shape="round"
          onClick={doRegister}
          disabled={submitting}
        >
          {submitting ? "Registering..." : "Register"}
        </IonButton>
      </div>
    </Fragment>
  );
};

export default RegisterSite;
